import { createBrowserRouter } from 'react-router-dom';
import { VerifyEmailPage } from './pages/VerifyEmailPage';
import { VerifySecurityCodePage } from './pages/VerifySecurityCodePage';
import { ViewIssuePage } from './pages/ViewIssuePage';
import { ViewDocumentPage } from './pages/ViewDocumentPage';
import { ViewFolderSharePage } from './pages/ViewFolderSharePage';
import { VerifyItemIdentifierPage } from './pages/VerifyItemIdentifierPage';
import { VerifyPdfUniqueCodePage } from './pages/VerifyPdfUniqueCodePage';
import { PdfErrorPage } from './pages/error/PdfErrorPage';
import { Authenticated } from './components/Authenticated';
import { ServerErrorPage } from './pages/error/ServerErrorPage';
import { PageNotFoundErrorPage } from './pages/error/PageNotFoundErrorPage';
import { AccessDeniedPage } from './pages/error/AccessDeniedPage';
import { ItemUnavailableErrorPage } from './pages/error/ItemUnavailableErrorPage';
import { UnauthorizedErrorPage } from './pages/error/UnauthorizedErrorPage';
import { ItemExpiredErrorPage } from './pages/error/ItemExpiredErrorPage';
import { ItemDownloadedPage } from './pages/ItemDownloadedPage';
import { ViewErrorPage } from './pages/error/ViewErrorPage';

const router = createBrowserRouter([
  {
    path: '/pdfs/:urlCode',
    element: (
      <Authenticated pdfVerify={true}>
        <VerifyPdfUniqueCodePage />
      </Authenticated>
    ),
  },
  {
    path: '/:urlCode',
    element: (
      <Authenticated>
        <VerifyItemIdentifierPage />
      </Authenticated>
    ),
  },
  {
    path: '/verify-email',
    element: (
      <Authenticated>
        <VerifyEmailPage />
      </Authenticated>
    ),
  },
  {
    path: '/verify-securityCode',
    element: (
      <Authenticated>
        <VerifySecurityCodePage />
      </Authenticated>
    ),
  },
  {
    path: '/view-issue',
    element: (
      <Authenticated>
        <ViewIssuePage />
      </Authenticated>
    ),
  },
  {
    path: '/view-item',
    element: (
      <Authenticated>
        <ViewIssuePage />
      </Authenticated>
    ),
  },
  {
    path: '/view-document',
    element: (
      <Authenticated>
        <ViewDocumentPage />
      </Authenticated>
    ),
  },
  {
    path: '/view-folder-share',
    element: (
      <Authenticated>
        <ViewFolderSharePage />
      </Authenticated>
    ),
  },
  {
    path: '/error',
    element: <ViewErrorPage />,
  },
  {
    path: '/access-denied',
    element: <AccessDeniedPage />,
  },
  {
    path: '/pdf-error',
    element: <PdfErrorPage />,
  },
  {
    path: '/server-error',
    element: <ServerErrorPage />,
  },
  {
    path: '/page-not-found',
    element: <PageNotFoundErrorPage />,
  },
  {
    path: '/unauthorized',
    element: <UnauthorizedErrorPage />,
  },
  {
    path: '/unavailable',
    element: <ItemUnavailableErrorPage />,
  },
  {
    path: '/expired',
    element: <ItemExpiredErrorPage />,
  },
  {
    path: '/success',
    element: <ItemDownloadedPage />,
  },
  { path: '*', element: <PageNotFoundErrorPage /> },
]);

export default router;
